import * as modellePage from "./settings-ausbildungsmodelle";
import * as dozentenPage from "./settings-dozenten";
import * as faecherPage from "./settings-faecher";
import * as rasterPage from "./settings-raster";
import * as raeumePage from "./settings-raeume";
import * as optionenPage from "./settings-stundenplan";

/**
 * Alle Stundenplan-Einstellungen unter einem Punkt.
 *
 * In der Seitennavigation der Einstellungen steht nur noch "Stundenplan"; die sechs
 * Bereiche liegen als Reiter auf der Seite. Der aktive Reiter steht im URL-Query
 * (#/einstellungen?tab=stundenplan&bereich=...), damit Deep-Links und der
 * Zurück-Button weiter funktionieren.
 */
type Tab = { id: string; label: string; render: (el: HTMLElement) => Promise<void> };

const TABS: Tab[] = [
  { id: "ausbildungsmodelle", label: "Ausbildungsmodelle", render: modellePage.render },
  { id: "dozenten", label: "Dozenten", render: dozentenPage.render },
  { id: "faecher", label: "Fächer", render: faecherPage.render },
  { id: "stundenraster", label: "Stundenraster", render: rasterPage.render },
  { id: "raeume", label: "Räume", render: raeumePage.render },
  { id: "optionen", label: "Optionen", render: optionenPage.render },
];

function activeTab(): string {
  const query = window.location.hash.split("?")[1] || "";
  const bereich = new URLSearchParams(query).get("bereich");
  return TABS.some(t => t.id === bereich) ? bereich! : TABS[0].id;
}

export async function render(el: HTMLElement) {
  el.innerHTML = `
    <div class="detail-tabs sp-tabs">
      ${TABS.map(t => `<button class="detail-tab" data-tab="${t.id}">${t.label}</button>`).join("")}
    </div>
    <div id="sp-tab-content"></div>`;

  const content = el.querySelector<HTMLElement>("#sp-tab-content")!;

  const renderActive = async () => {
    const current = activeTab();
    el.querySelectorAll<HTMLButtonElement>(".detail-tab").forEach(b =>
      b.classList.toggle("active", b.dataset.tab === current));
    content.innerHTML = `<div style="display:flex;align-items:center;justify-content:center;height:200px"><div class="spinner"></div></div>`;
    await TABS.find(t => t.id === current)!.render(content);
  };

  el.querySelectorAll<HTMLButtonElement>(".detail-tab").forEach(btn => {
    btn.addEventListener("click", () => {
      // pushState statt replaceState: die Bereiche der Einstellungen landen als
      // Sidebar-Links ohnehin im Verlauf, die Reiter hier sollen sich genauso
      // verhalten. pushState loest kein hashchange aus, deshalb rendern wir selbst;
      // beim Zurueckgehen uebernimmt der Router in app.ts.
      history.pushState(null, "", `#/einstellungen?tab=stundenplan&bereich=${btn.dataset.tab}`);
      renderActive();
    });
  });

  await renderActive();
}
